import { createSlice } from '@reduxjs/toolkit';
import { _setStagedEmployeeDocuments } from './stagedEmployeeDocumentsAction';

export const stagedEmployeeDocumentsSlice = createSlice({
  name: 'delta/stagedEmployeeDocuments',
  initialState: null,
  reducers: {
    setStagedEmployeeDocuments: _setStagedEmployeeDocuments,
    resetStagedEmployeeDocuments: () => null,
  },
});

export const { setStagedEmployeeDocuments, resetStagedEmployeeDocuments } =
  stagedEmployeeDocumentsSlice.actions;

export default stagedEmployeeDocumentsSlice.reducer;
